import { EEntities } from '@/types'
import { IHomeTableItem } from '@/types/data-objects/items'
import { ICustomField } from '@/api/types/response.types'

export const HomeTableProps = {
  /* Custom fields flagged to show on listings. Values on each item are matched against these. */
  customFields: {
    type: Array as () => ICustomField[],
    default: (): ICustomField[] => [],
  },

  type: {
    type: String as () => EEntities,
    required: true,
  },

  tableData: {
    type: Array as () => IHomeTableItem[],
    default: (): IHomeTableItem[] => [],
  },

  isLoading: {
    type: Boolean,
    default: false,
  },

  searchQuery: {
    type: String,
    default: '',
  },

  fromAll: {
    type: Boolean,
    default: false,
  },

  fromEntityHome: {
    type: Boolean,
    default: false,
  },
}
